// Libraries
var React = require('react');

// Styles
require('./Penalties.scss');

// Assets
var footballDark = require('./Football_dark.svg');
var footballMiss = require('./Football_miss.svg');

class Penalties extends React.Component {

    render() {
        var homePenaltiesScored = this.props.penalties.filter(x => x.IsHomeTeam === true && x.Outcome === "Scored");
        var awayPenaltiesScored = this.props.penalties.filter(x => x.IsHomeTeam === false && x.Outcome === "Scored");

        return (
            <div className="Penalties">
                <div className="Penalties__goals--left">
                    {this.props.penalties.filter(x => x.IsHomeTeam === true).map(function (penalty, index) {
                        if(penalty.Outcome === "Scored") {
                            return (<img src={footballDark} alt="Penalty scored" key={index} />)
                        } else {
                            return (<img src={footballMiss} alt="Penalty missed" key={index} />)
                        }
                    })}
                </div>
                <div className="Penalties__score">
                    <div className="wrapper">
                        <div className="Penalties__score--left">
                            <img src={this.props.homeCrestUrl} alt="Home team crest" />
                        </div>
                        <div className="Penalties__score--middle">
                            <p className="score">{homePenaltiesScored.length} - {awayPenaltiesScored.length}</p>
                            <p className="time">{this.props.displayMinute}</p>
                            {this.props.aggregateScore && <p className="time">(Agg {this.props.aggregateScore})</p>}
                        </div>
                        <div className="Penalties__score--right">
                            <img src={this.props.awayCrestUrl} alt="Away team crest" />
                        </div>
                    </div>
                </div>
                <div className="Penalties__goals--right">
                    {this.props.penalties.filter(x => x.IsHomeTeam === false).map(function (penalty, index) {
                        if(penalty.Outcome === "Scored") {
                            return (<img src={footballDark} alt="Penalty scored" key={index} />)
                        } else {
                            return (<img src={footballMiss} alt="Penalty missed" key={index} />)
                        }
                    })}
                </div>
            </div>
		)
	}
}

module.exports = Penalties;


// WEBPACK FOOTER //
// ./src/components/MDC/LiveGameSummary/Penalties.js